<!-- M02 §3 · the upload step as the design draws it (`isCOnboarding`, `f.isUpload`):
     a dashed panel with the preview at the top, the actions under it and the
     rules last. It used to be a one-line row with a tiny icon, which read as a
     broken field on a screen that is otherwise all cards. -->

<div class="ob-drop" [class.is-dragging]="dragging()" [class.is-busy]="busy()">
	<label
		class="ob-drop__zone"
		(dragover)="onDragOver($event)"
		(dragleave)="onDragLeave($event)"
		(drop)="onDrop($event)"
	>
		<input type="file" class="ob-drop__input" [accept]="accept()" [disabled]="busy()" (change)="onPick($event)" />

		<!-- The file already stored, shown as itself: the photo, the video with
		     its controls, or the document tile. Nothing else tells the candidate
		     that what they uploaded is the right file. -->
		<span class="ob-drop__preview">
			@if (current(); as file) {
				@switch (kind()) {
					@case ('photo') {
						<img class="ob-drop__image" [src]="file.publicUrl" alt="" />
					}
					@case ('video') {
						<!-- Stop the click: inside a <label>, hitting play would open the
						     file picker instead of playing. -->
						<video class="ob-drop__video" [src]="file.publicUrl" controls preload="metadata" (click)="$event.preventDefault()">
							<track kind="captions" />
						</video>
					}
					@default {
						<span class="ob-drop__doc">
							<lucide-icon [name]="icon()" [size]="26" aria-hidden="true"></lucide-icon>
							<span class="ob-drop__docname">{{ file.originalName }}</span>
						</span>
					}
				}
			} @else {
				<span class="ob-drop__placeholder">
					<lucide-icon [name]="icon()" [size]="22" aria-hidden="true"></lucide-icon>
					{{ 'merit.onboarding.upload.' + kind() + '.title' | transloco }}
				</span>
			}
		</span>

		<span class="ob-drop__actions">
			<span class="ob-drop__cta" [class.is-busy]="busy()">
				@if (busy()) {
					{{ (probing() ? 'merit.onboarding.upload.checking' : 'merit.onboarding.upload.uploading') | transloco }}
				} @else {
					{{ (current() ? 'merit.onboarding.upload.replace' : 'merit.onboarding.upload.browse') | transloco }}
				}
			</span>
			@if (current(); as file) {
				<a class="ob-drop__ghost" [href]="file.publicUrl" target="_blank" rel="noopener" (click)="$event.stopPropagation()">
					{{ 'merit.onboarding.upload.open' | transloco }}
				</a>
			}
		</span>

		<span class="ob-drop__hint">
			{{ 'merit.onboarding.upload.' + kind() + '.hint' | transloco: { max: maxMb() } }}
		</span>
	</label>

	@if (current(); as file) {
		<div class="ob-drop__current">
			<lucide-icon name="CircleCheck" [size]="15"></lucide-icon>
			<span class="ob-drop__name">{{ file.originalName }}</span>
			@if (currentSize()) {
				<span class="ob-drop__meta">{{ currentSize() }}</span>
			}
			@if (file.durationSeconds) {
				<span class="ob-drop__meta">{{ file.durationSeconds }} s</span>
			}
		</div>
	}

	@if (error(); as message) {
		<p class="ob-drop__error" role="alert">
			<lucide-icon name="TriangleAlert" [size]="15"></lucide-icon>
			<span>{{ message }}</span>
		</p>
	}
</div>
